module.exports = __webpack_public_path__ + "static/media/TG.70920835.svg";